import React from 'react'
import { get } from 'lodash-es'
import TriggersWarpper from './TriggersWarpper'

const ElementRender = function ({ layouts }) {
  const leftElements = get(layouts, 'leftElements', [])
  const rightElements = get(layouts, 'rightElements', [])
  if (leftElements.length === 0 && rightElements.length === 0) {
    return null
  }
  return (
    <div className="w-full flex flex-wrap flex-col md:flex-row justify-between md:items-center h-auto">
      <div
        className="flex flex-row justify-start items-center flex-wrap"
        style={{ gap: '12px' }}
      >
        {leftElements.map((element, index) => {
          return (
            <React.Fragment key={`${element}-${index}`}>
              <TriggersWarpper element={element} index={index} />
            </React.Fragment>
          )
        })}
      </div>
      <div
        className="flex flex-row justify-center md:justify-end items-center flex-1"
        style={{ gap: '12px' }}
      >
        {rightElements.map((element, index) => {
          return (
            // <div key={`${element}-${index}`}>
            <TriggersWarpper
              element={element}
              index={index}
              key={`${element}-${index}`}
            />
            // </div>
          )
        })}
      </div>
    </div>
  )
}

export default ElementRender
